import { createAction } from '@reduxjs/toolkit'
import { RefundAmountRequest } from '../api'

export const submitAmountRefund = createAction<RefundAmountRequest>('REFUNDS_SUBMIT_AMOUNT')
